<template>
  <div class="lazy-container">
    <sub-menu id="section-submenu" nohide="true"></sub-menu>
    <section class="mt3" v-if="team">
      <div class="col-12 center mb3">
        <h2 class="caps">{{appTitle}}</h2>
      </div>
      <div class="col-12 md-col-10 lg-col-10 mx-auto flex flex-wrap">
        <person-preview
          v-for="person in team.current"
          :content="person"
          :key="person.id"
          :showDetails="true"
          classes="md-col-4"></person-preview>
      </div>
    </section>

    <section v-if="team && team.extended">
      <div class="col-12 center mb3">
        <h2 class="caps">Research Fellows</h2>
      </div>
      <div class="col-12 md-col-10 lg-col-10 mx-auto flex flex-wrap">
        <person-preview
          v-for="person in team.extended"
          :content="person"
          :key="person.id"
          :showDetails="true"
          classes="md-col-4"></person-preview>
      </div>
    </section>

    <section v-if="team && team.past">
      <div class="col-12 center mb3">
        <h2 class="caps">Past</h2>
      </div>
      <div class="col-12 md-col-10 lg-col-10 mx-auto flex flex-wrap">
        <person-preview
          v-for="person in team.past"
          :content="person"
          :key="person.id"
          :showDetails="false"
          classes="md-col-3"></person-preview>
      </div>
    </section>

    <section id="page" v-if="team && team.description">
      <div class="content sans">
        <div
          v-for="(block, index) in team.description"
          class="block-wrapper"
          :key="index">
          <h3 class="block-heading mb2" v-if="block.block_heading">
            {{ block.block_heading }}
          </h3>
          <div
            v-if="block.block_content && block.block_content.columns === '1'"
            class="block-content"
            v-html="block.block_content.column_1"></div>
          <div
            v-else-if="block.block_content"
            class="block-content flex two-col">
            <div
              v-html="block.block_content.column_1"
              class="block-column col-6"></div>
            <div
              v-html="block.block_content.column_2"
              class="block-column col-6"></div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import SubMenu from '@/components/SubMenu'
import PersonPreview from '@/components/PersonPreview'
import { mapState, mapActions } from 'vuex'

export default {

  name: 'Team',

  data () {
    return {
      lazyContainer: this.lazyLoad({
        elements_selector: ".lazy-container img"
      })
    }
  },

  mounted () {
    this.$nextTick(function () {
      this.lazyContainer.update()
    })
  },

  metaInfo () {
    let title = 'Team'
    return {
      title: title,
      meta: [
        { name: 'og:title', content: `${process.env.VUE_APP_TITLE} → ${title}` },
        { name: 'twitter:title', content: `${process.env.VUE_APP_TITLE} → ${title}` },
        { name: 'og:image', content: '/fa-share-lg.png' },
        { name: 'twitter:image', content: '/fa-share-lg.png' },
        { name: 'og:url', content: `${window.location.origin}/${this.$route.fullPath}` },
        { name: 'og:type', content: 'website' },
        { name: 'og:description', content: this.siteDescription() },
        { name: 'twitter:description', content: this.siteDescription() }
      ]
    }
  },

  components: {
    PersonPreview,
    SubMenu
  },

  computed: {
    ...mapState([
      'appTitle',
      'pages'
    ]),
    team () {
      if (this.pages.hasOwnProperty('team')) {
        return this.pages['team'].acf
      } else {
        return false
      }
    },
  },

  methods: {
    ...mapActions([
      'getPage'
    ])
  },

  created: function () {
    this.getPage('team')
  },

  watch: {
    'team' () {
      this.$nextTick(function () {
        this.lazyContainer.update()
      })
    }
  }
}
</script>

<style lang="css" scoped>
#page {
  margin-top: 3em;

  .block-wrapper {
    margin-bottom: 6em;

    &:last-child {
      margin-bottom: 0;
    }
  }
}
</style>
